import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--commerce/bac-subscription-details-banner';

import { TrialEndedOfferToBuyBanner } from '../../../trial-ended-offer-to-buy-banner';

type HydrationResult = {
	directBuyUrl?: string;
	offeringName: string;
	productName: string;
	toOfferingName?: string;
};

type MessageFrontendProps = HydrationResult & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({
			directBuyUrl,
			offeringName,
			productName,
			toOfferingName,
			dismiss,
		}: MessageFrontendProps) =>
			directBuyUrl ? (
				<TrialEndedOfferToBuyBanner
					directBuyUrl={directBuyUrl}
					offeringName={offeringName}
					productName={productName}
					toOfferingName={toOfferingName}
					dismiss={dismiss}
				/>
			) : null,
	},
});
